import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Web\ProductPage\ProductPageUploadSessionController::__invoke
* @see Http/Controllers/Web/ProductPage/ProductPageUploadSessionController.php:19
* @route '/product-page/upload-session'
*/
const ProductPageUploadSessionController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: ProductPageUploadSessionController.url(options),
    method: 'get',
})

ProductPageUploadSessionController.definition = {
    methods: ["get","head"],
    url: '/product-page/upload-session',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Web\ProductPage\ProductPageUploadSessionController::__invoke
* @see Http/Controllers/Web/ProductPage/ProductPageUploadSessionController.php:19
* @route '/product-page/upload-session'
*/
ProductPageUploadSessionController.url = (options?: RouteQueryOptions) => {
    return ProductPageUploadSessionController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Web\ProductPage\ProductPageUploadSessionController::__invoke
* @see Http/Controllers/Web/ProductPage/ProductPageUploadSessionController.php:19
* @route '/product-page/upload-session'
*/
ProductPageUploadSessionController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: ProductPageUploadSessionController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Web\ProductPage\ProductPageUploadSessionController::__invoke
* @see Http/Controllers/Web/ProductPage/ProductPageUploadSessionController.php:19
* @route '/product-page/upload-session'
*/
ProductPageUploadSessionController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: ProductPageUploadSessionController.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Web\ProductPage\ProductPageUploadSessionController::__invoke
* @see Http/Controllers/Web/ProductPage/ProductPageUploadSessionController.php:19
* @route '/product-page/upload-session'
*/
const ProductPageUploadSessionControllerForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: ProductPageUploadSessionController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Web\ProductPage\ProductPageUploadSessionController::__invoke
* @see Http/Controllers/Web/ProductPage/ProductPageUploadSessionController.php:19
* @route '/product-page/upload-session'
*/
ProductPageUploadSessionControllerForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: ProductPageUploadSessionController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Web\ProductPage\ProductPageUploadSessionController::__invoke
* @see Http/Controllers/Web/ProductPage/ProductPageUploadSessionController.php:19
* @route '/product-page/upload-session'
*/
ProductPageUploadSessionControllerForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: ProductPageUploadSessionController.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

ProductPageUploadSessionController.form = ProductPageUploadSessionControllerForm

export default ProductPageUploadSessionController